<!--
 * @Author:
 * @Description:收单-auth交易自动capture/void的设定和应用  https://jira.ronhan.com/browse/ON3-15329
 * @Date: 2024-11-27 10:41:54
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/settings/authCapture/index.vue
-->
<template>
<div class="container">
    <el-button class="save-btn" @click="save" :disabled="!isEdit">{{ $t('message.settings.authCapture.saveBtn') }}</el-button>

    <div class="card">
      <div class="title-desc">
        <div class="title">
          {{ $t('message.settings.authCapture.title') }}
        </div>
        <div class="desc">
          {{ $t('message.settings.authCapture.desc') }}
        </div>
      </div>

      <div class="operation-area">
        <div >
          <div class="head" v-if="currLang === 'zh'">
            在授权(Auth)
            <el-select style="margin: 0 12px;width: 68px;" size="small" v-model="submitParam.authAutoDelayDays" @change="isEdit = true">
              <el-option
                v-for="item in 6"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select> 天后，交易将被：
          </div>
          <div class="head" v-else>
            <el-select style="margin-right: 12px;width: 68px;"  v-model="submitParam.authAutoDelayDays" @change="isEdit = true">
              <el-option
                v-for="item in 6"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            days after Auth, transaction will be:
          </div>
        </div>

        <div class="body">
          <el-radio-group v-model="submitParam.authAutoTxnType" @change="isEdit = true">
              <el-radio :label="'capture'">{{$t('message.settings.authCapture.captureRadio')}}</el-radio>
              <el-radio :label="'void'">{{$t('message.settings.authCapture.voidRadio')}}</el-radio>
            </el-radio-group>
          </div>
      </div>
    </div>

    <!-- 这里没有反，因为组件内部的按钮位置是固定的 -->
    <custom-message
     ref="customMessage"
     cancelButtonText="message.settings.authCapture.leaveConfirmText"
     confirmButtonText="message.settings.authCapture.leaveCancelText"
     ></custom-message>

  </div>
</template>

<script>
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { getAuthCapture, saveAuthCapture } from '@/views/settings/authCapture/api/authCapture-service';
export default {
  name: 'AuthCapture',
  components: {
    CustomMessage,
  },
  /** ***********  ✨ Codeium Command ⭐  *************/
  /**
   * Data
   * @returns {{form: {}}}
   */
  /** ****  301826cc-aa0f-4bba-be23-a8dc133e942a  *******/
  data() {
    return {
      isEdit: false,
      submitParam: {
        authAutoTxnType: 'capture',
        authAutoDelayDays: '6',
      },
    };
  },
  computed: {
    currLang() {
      const lang = this.$store.getters.app.currentLan;
      const language = lang === 'zh-cn' ? 'zh' : lang;
      return language;
    },
  },
  created() {
    this.getData();
  },
  mounted() {

  },
  methods: {
    async save() {
      await saveAuthCapture(this.submitParam);
      ShowSuccessMessage(this.$t('message.settingsSuccessfulTip'));
      this.isEdit = false;

      // this.$refs.customMessage.openHttpModal({
      //   titleHtml: this.$t('message.common.prompt'),
      //   contentHtml: `${this.$t('message.common.deleteConfirm')}?`,
      //   httpFunction: deleteByCountry,
      //   params: { country: data.country },
      //   successFunction: (),
      // });
    },
    async getData() {
      const res = await getAuthCapture();
      res && (this.submitParam = res);

      if (!res) {
        this.isEdit = true;
      }
    },

  },
  // 如果未保存 离开之前要确认下
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$refs.customMessage.openDefaultModal({
        contentHtml: this.$t('message.settings.authCapture.leaveTips'),
        titleHtml: this.$t('message.settings.authCapture.notice'),
        onCallback: (action) => {
          if (action === 'confirm') {
            next(false);
          } else {
            next();
          }
        },
      }, '');
    } else {
      next();
    }
  },

};
</script>

<style scoped lang="scss">

.container {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.card {
  width: 100%;
  padding: 24px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #EFEFF4;
  display: flex;
  align-items: center;
}

.save-btn {
  margin-top: 16px;
  margin-bottom: 33px;
}

.title-desc {
  .title {
    font-family: Open Sans, Open Sans;
    font-weight: bold;
    font-size: 18px;
    color: #1A202C;
    line-height: 26px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 4px
  }
  .desc {
    font-family: PingFang HK, PingFang HK;
    font-weight: 400;
    font-size: 14px;
    color: #667085;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.operation-area {
  margin-left: 100px;
  .head {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-bottom: 21px;

    font-family: Open Sans, Open Sans;
    font-weight: 400;
    font-size: 14px;
    color: #1A202C;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
